export const SERP_POSITION_FIVE = 5
export const SERP_POSITION_FIFTEEN = 15
export const SERP_POSITION_THIRTY = 30
